export default {
    FIXA: 1,
    DINAMICA: 2,
    UNICA: 3
}